// sagas/userSaga.js

import { put, takeLatest, call } from 'redux-saga/effects';
import {
  PROFILE_UPDATE_FAILURE, PROFILE_UPDATE_SUCCESS, SIGNIN_FAILURE, SIGNIN_SUCCESS, SIGNUP_FAILURE, SIGNUP_REQUEST, SIGNUP_SUCCESS, STUDENT_SIGNIN_REQUEST, TEACHER_SIGNIN_REQUEST, USER_PROFILE_UPDATE_REQUEST
  , OTP_REQUEST, OTP_REQUEST_SUCCESS, OTP_REQUEST_FAILURE,
  VARIFY_OTP,
  VARIFY_OTP_SUCCESS,
  VARIFY_OTP_FAILURE,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE
} from '../actions/userActions'; import axios from 'axios';
import axiosInstance from '../api/axiosInstance';

const API_URL = process.env.REACT_APP_BACKEND_URL;

function* handleSignup(action) {
  try {
    const response = yield call(axios.post, `${API_URL}/register`, action.payload);


    if (response.data) {
      yield put({ type: SIGNUP_SUCCESS });
    }
  } catch (error) {
    console.error(error);
    yield put({ type: SIGNUP_FAILURE });
  }
}


function* handleTeacherSignin(action) {
  try {
    const { email, password } = action.payload;

    const response = yield call(axios.post, `${API_URL}/teacherlogin`,
      { email, password }
    );


    if (response.data.message === "User logged in successfully") {
      yield put({ type: SIGNIN_SUCCESS, payload: { userId: response.data.userId, userRole: response.data.userRole } });
      localStorage.setItem('userId', response.data.userId);
      localStorage.setItem('userRole', 'creator');
      localStorage.setItem('accessToken', response.data.accessToken);
      localStorage.setItem('refreshToken', response.data.refreshToken);
    }
  } catch (error) {
    // console.error(error);
    yield put({ type: SIGNIN_FAILURE });
  }
}


function* handleStudentSignin(action) {
  try {
    const { email, password } = action.payload;

    const response = yield call(
      axios.post, `${API_URL}/studentlogin`,
      { email, password }
      );


    // 2. Handle successful login
    if (response.data.message === "User logged in successfully") {
      yield put({ type: SIGNIN_SUCCESS, payload: { userId: response.data.userId, userRole: response.data.userRole } });

      // 5. Store minimal session data
      localStorage.setItem('userId', response.data.userId);
      localStorage.setItem('userRole', 'student');
      localStorage.setItem('accessToken', response.data.accessToken);
      localStorage.setItem('refreshToken', response.data.refreshToken);
      localStorage.setItem('accessTokenExpiresAt', response.data.accessTokenExpiresAt);

    } else {
      throw new Error(response.data.message || 'Login failed');
    }
  } catch (error) {
    yield put({ type: SIGNIN_FAILURE });
    // console.error(error);
  }
}







function* handleUpdateProfile(action) {
  try {
    // Make the API call to update the profile
    const formData = new FormData();
    for (const key in action.payload) {
      formData.append(key, action.payload[key]);
    }
        // Let the browser set the content-type with boundary
        const config = {
          headers: {
            ...axiosInstance.defaults.headers,
            'Content-Type': undefined // Let browser set it
          }
        };
    

        const response = yield call(axiosInstance.put, "/updateprofile", formData, config);
    // Check if the response indicates a successful update
    if (response.data) {
      // Dispatch an action indicating success
      yield put({ type: PROFILE_UPDATE_SUCCESS });
    }
  } catch (error) {
    // If there's an error, log it and dispatch an action indicating failure
    // console.error(error);
    yield put({ type: PROFILE_UPDATE_FAILURE });
  }
}



function* generateOtp(action) {
  try {
    const response = yield call(axiosInstance.post, "/generateopt", action.payload);
    if (response.data) {

      yield put({ type: OTP_REQUEST_SUCCESS, payload: response.data.message });
    }
  } catch (error) {
    console.error(error.message);
    yield put({ type: OTP_REQUEST_FAILURE });
  }
}

function* resetPassword(action) {
  try {
    const response = yield call(axiosInstance.post, "/reset", action.payload);
    if (response.data) {

      yield put({ type: FORGOT_PASSWORD_SUCCESS, payload: response.data.message });
    }
  } catch (error) {

    yield put({ type: FORGOT_PASSWORD_FAILURE });
  }
}


function* varifyOtp(action) {
  try {
    const response = yield call(axiosInstance.post, "/varifyopt", action.payload);
    if (response.data) {
      yield put({ type: VARIFY_OTP_SUCCESS, payload: response.data });
    }
  } catch (error) {
    console.error(error);
    yield put({ type: VARIFY_OTP_FAILURE });
  }
}

function* userSaga() {
  yield takeLatest(SIGNUP_REQUEST, handleSignup);
  yield takeLatest(TEACHER_SIGNIN_REQUEST, handleTeacherSignin);
  yield takeLatest(STUDENT_SIGNIN_REQUEST, handleStudentSignin);
  yield takeLatest(USER_PROFILE_UPDATE_REQUEST, handleUpdateProfile);

  yield takeLatest(OTP_REQUEST, generateOtp);
  yield takeLatest(VARIFY_OTP, varifyOtp);
  yield takeLatest(FORGOT_PASSWORD, resetPassword);



}

export default userSaga;
